import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { WhatsappLogo, Truck } from "@phosphor-icons/react";
import { whatsappLink } from "@/data/site";

export function FloatingButtons() {
  const [showSticky, setShowSticky] = useState(true);

  useEffect(() => {
    const onScroll = () => setShowSticky(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* WhatsApp */}
      <a
        href={whatsappLink()}
        target="_blank"
        rel="noreferrer nofollow"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-20 right-5 sm:bottom-6 z-40 grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-xl shadow-green-600/30 hover:scale-110 transition-transform"
      >
        <WhatsappLogo weight="fill" className="h-7 w-7" />
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping -z-10" />
      </a>

      {/* Sticky Book Pickup (mobile bottom bar) */}
      <div
        className={`fixed bottom-0 left-0 right-0 z-30 sm:hidden transition-transform duration-300 ${
          showSticky ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <Link
          to="/book-pickup"
          data-testid="sticky-book-pickup"
          className="flex items-center justify-center gap-2 bg-korea-blue text-white font-semibold py-4 shadow-2xl"
        >
          <Truck weight="fill" className="h-5 w-5" /> Book Free Pickup
        </Link>
      </div>
    </>
  );
}
